import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-label-value',
  imports: [CommonModule],
  templateUrl: './label-value.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./label-value.scss'],
})
export class LabelValue {
  label = input<string | null | undefined>(null);
  value = input<string | null | undefined>(null);
  reverse = input<boolean>(false);
}
